import { Component, inject } from "@angular/core";
import { ThemeService } from "../services/theme.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, Subject, takeUntil } from "rxjs";
import { SharedService } from "./shared/shared.service";
import { AuthenticationService } from "../services/authentication.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ChatbotComponent } from "./screens/ai/chatbot/components/chatbot/chatbot.component";
import { FidaiFeatureService } from "./screens/ai/services/fidai-feature.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.less",
})
export class AppComponent {
  title = "fidivio-webApp";
  activeStep: string = "";
  isGreyBackground = false;
  showStepper: boolean = false;
  private router = inject(Router);
  private stepperVisibleRoutes: RegExp[] = [
    /^\/configuration\/users$/, // /configuration/users
    /^\/configuration\/users\/[^/]+$/, // /configuration/users/123
    /^\/configuration\/programsetup\/[^/]+$/, // /configuration/programsetup/preview
    /^\/configuration\/roles$/, // /configuration/roles
    /^\/configuration\/featuresetup$/, // /configuration/featuresetup
    /^\/configuration\/connectors$/, // /configuration/featuresetup
    /^\/configuration\/connectors\/[^/]+$/,
    /^\/data-input\/[^/]+$/, // /data-input/123
    /^\/management-reports\/[^/]+$/,
    /^\/home$/,
    /^\/partners$/,
    /^\/partners\/details\/[^/]+$/,
    /^\/ai-overview$/,
    /^\/accounting\/[^/]+$/,
    /^\/financial-statements\/[^/]+$/,
    /^\/projections$/,
    /^\/calculator$/,
    /^\/version$/,
  ];
  private greyBackgroundRoutes: RegExp[] = [
    /^\/configuration\/programsetup(\/|$)/,
    /^\/partners\/details\/[^/]+$/,
  ];

  // Define the routes where the side-stepper should be visible
  private destroy$ = new Subject<void>();
  currentDashboard: string = "";
  constructor(
    public themeService: ThemeService,
    private sharedService: SharedService,
    private matDialog: MatDialog,
    private authenticationService: AuthenticationService,
    private fidaiFeatureService: FidaiFeatureService,
  ) {
    // this.router.events
    //   .pipe(
    //     filter((event) => event instanceof NavigationEnd),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe((event: NavigationEnd) => {
    //     this.activeStep = event.url.split("/")[1];
    //     this.showStepper = this.shouldShowStepper(event.urlAfterRedirects);
    //   });
  }

  get programData() {
    return this.sharedService.programData;
  }

  get isLoggedIn() {
    return this.authenticationService.isAuthenticated();
  }

  get isAiChatbotEnabled() {
    return this.fidaiFeatureService.isAiChatbotEnabled();
  }

  private shouldShowStepper(url: string): boolean {
    return this.stepperVisibleRoutes.some((routeRegex) => routeRegex.test(url));
  }

  private shouldApplyGreyBackgroundStyle(url: string): boolean {
    return this.greyBackgroundRoutes.some((routeRegex) =>
      routeRegex.test(url),
    );
  }

  ngOnInit(): void {
    this.themeService.initTheme();
    this.authenticationService.listenTokenExpiry();
    // handle initial load
    this.handleRoute(this.router.url);

    // handle future navigation
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRoute(event.urlAfterRedirects);
      });
  }

  private handleRoute(url: string): void {
    this.activeStep = url.split("/")[1];
    this.isGreyBackground = this.shouldApplyGreyBackgroundStyle(url);
    this.showStepper = this.shouldShowStepper(url);

    const segments = url.split("/").filter(Boolean);
    this.currentDashboard = segments[segments.length - 1];
  }

  // toggleTheme(): void {
  //   this.themeService.toggleTheme();
  // }

  openFidiChat() {
    if (!this.isAiChatbotEnabled) {
      return;
    }

    const dialogConfig: MatDialogConfig = {
      panelClass: ["side-panel-right", "hidable-panel"],
      hasBackdrop: true,
      ariaLabel: "User",
      height: "100vh",
      closeOnNavigation: true,
      maxWidth: "1200px", // ← add this
      disableClose: true,
      enterAnimationDuration: "0ms",
      position: {
        top: "0px",
        right: "0px",
      },
      data: this.currentDashboard,
    };
    window.scrollTo(0, 0);
    const dialogRef = this.matDialog.open(ChatbotComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList?.remove("cdk-global-scrollblock");
    });

    dialogRef.afterOpened().subscribe(() => {
      document.body.classList.add("cdk-global-scrollblock");
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
